module.exports = __webpack_public_path__ + "img/GS_Profile-Lesego Lefifi.afcf7568.png";